import { backendFetch } from './apiUtils';

export const postTaricSearch = async (commCode) => {
  return await backendFetch({
    url: 'taricInfo/taricSearch',
    options: {
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ commCode }),
    },
    method: 'POST',
  });
};

export const postTaricDetails = async (commCode) => {
  return await backendFetch({
    url: 'taricInfo/taricDetails',
    options: {
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ commCode }),
    },
    method: 'POST',
  });
};

export const putTaricUpdate = async (data) => {
  return await backendFetch({
    url: 'taricInfo/taricUpdate',
    options: {
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data }),
    },
    method: 'PUT',
  });
};

export const postTaricHistory = async (commCode) => {
  return await backendFetch({
    url: 'taricInfo/taricHistory',
    options: {
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ commCode }),
    },
    method: 'POST',
  });
};
